export default __webpack_public_path__ + "118625a0e9fbf45bc305b264e1e52ba7.png";